import {
  focusModalPanel,
  getOpenModal,
  restoreModalTriggerFocus,
  setAriaHidden,
  setBodyLocked,
  storeModalTrigger
} from "./modal-utils.js";

const OPEN_CLASS = "content-modal--open";
const MODAL_SELECTOR = ".content-modal";
const PANEL_SELECTOR = ".content-modal__panel";

const openModal = (modal, documentReference, triggerElement) => {
  storeModalTrigger(modal, triggerElement);
  modal.removeAttribute("hidden");
  modal.classList.add(OPEN_CLASS);
  setAriaHidden(modal, false);
  setBodyLocked(documentReference, true);
  focusModalPanel(modal, PANEL_SELECTOR);
};

const closeModal = (modal, documentReference) => {
  modal.classList.remove(OPEN_CLASS);
  modal.setAttribute("hidden", "");
  setAriaHidden(modal, true);
  setBodyLocked(documentReference, false);
  restoreModalTriggerFocus(modal);
};

export const initContentModals = (documentReference = document) => {
  documentReference.addEventListener("click", (event) => {
    const openHost = event.target.closest("[data-content-modal-open]");
    if (openHost) {
      event.preventDefault();
      const targetId = openHost.getAttribute("data-content-modal-open")?.trim();
      if (!targetId) {
        return;
      }

      const modal = documentReference.getElementById(targetId);
      if (!modal?.classList.contains("content-modal")) {
        return;
      }

      openModal(modal, documentReference, openHost);
      return;
    }

    if (!event.target.closest("[data-content-modal-close]")) {
      return;
    }

    const modalToClose = event.target.closest(".content-modal");
    if (!modalToClose?.classList.contains(OPEN_CLASS)) {
      return;
    }

    closeModal(modalToClose, documentReference);
  });

  documentReference.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") {
      return;
    }

    const openModalElement = getOpenModal(documentReference, MODAL_SELECTOR, OPEN_CLASS);
    if (openModalElement) {
      closeModal(openModalElement, documentReference);
    }
  });
};
